/* global globalThis */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import "./SelfLearning.scss";
import { useSearchQuery } from '../../services/SearchQueryContext';

/**
 * Course Material Container.
 * @param props
 * @returns {*}
 * @constructor
 */

function TopicMaterialContainer({
    course_id,
    mySectionData,
    activeItem,
    setActiveItem,
}) {

    const { setNewFlag } = useSearchQuery();

    useEffect(() => {
        setNewFlag(true);
        return () => setNewFlag(false);
    }, [setNewFlag]);

    useEffect(() => {
        if (course_id === undefined || activeItem || mySectionData === undefined) {
            return;
        }

        setActiveItem({
            data: mySectionData?.data?.section?.[0],
            sectionData: mySectionData,
        });
    }, [course_id, activeItem, mySectionData, setActiveItem]);

    return null;
}

TopicMaterialContainer.propTypes = {
    course_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mySectionData: PropTypes.shape({
        data: PropTypes.shape({
            section: PropTypes.array,
        }),
    }),
    activeItem: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    setActiveItem: PropTypes.func,
};

export default TopicMaterialContainer;
